import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

export class ChatMessageValidationError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'ChatMessageValidationError',
    }) /* istanbul ignore next */;

    Object.setPrototypeOf(this, ChatMessageValidationError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ChatMessageValidationError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
